module.exports = __webpack_public_path__ + "static/img/FWF.cc9ffdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FWF.png
// module id = EA8S
// module chunks = 18